import moment from 'moment';

const isValidDate = function (input) {
  var date = moment(input, 'DD.MM.YYYY', true);
  return date.isValid();
};
const isBefore = function (input) {
  /**
   * format('L') defines the default date format 'MM/DD/YYYY'
   */
  var currentTimeStamp = moment(moment().format('L')).toDate().getTime();
  var inputTimeStamp = moment(input, 'DD.MM.YYYY', true).toDate().getTime();
  var isValid = false;
  if (inputTimeStamp >= currentTimeStamp) {
    isValid = true;
  }
  return isValid;
};

const isValidMonthYear = function (input) {
  var date = moment(input, 'MM.YYYY', true);
  return date.isValid();
};

const isBeforeMonthYear = function (input) {
  const date = '01.' + input;
  const currentDate = moment(moment().format('L')).toDate();
  const inputDate = moment(date, 'DD.MM.YYYY', true).endOf('month');
  let isValid = false;
  if (inputDate.isAfter(currentDate)) {
    isValid = true;
  }
  return isValid;
};

const isMaximumMonthYear = function (input) {
  const MAX_YEAR = 10;
  const date = '01.' + input;
  const currentYear = '01.12.' + moment().year();
  const currentDate = moment(currentYear, 'DD.MM.YYYY', true);
  const futureDate = moment(currentDate).add(MAX_YEAR, 'Y').endOf('month');
  const expiryDate = moment(date, 'DD.MM.YYYY', true).endOf('month');
  let inValid = false;
  if (!expiryDate.isAfter(futureDate)) {
    inValid = true;
  }
  return inValid;
};

const isFutureDate = function (input) {
  return moment(input, 'DD.MM.YYYY', true).isAfter(moment());
};

const isToday = function (input) {
  var currentdate = moment(moment().format('L')).toDate();
  let isToday = false;
  if (moment(input, 'DD.MM.YYYY', true) && input === moment(currentdate).format('DD.MM.YYYY')) {
    isToday = true;
  }
  return isToday;
};

export { isValidDate, isBefore, isBeforeMonthYear, isMaximumMonthYear, isValidMonthYear, isFutureDate, isToday };
